import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import MUIDataTable from "mui-datatables";

var DataTable = function DataTable(_ref) {
  var data = _ref.data,
      key = _ref.key,
      translation = _ref.translation,
      title = _ref.title,
      options = _ref.options,
      columns = _ref.columns,
      className = _ref.className;
  // console.log("datatable data", data);
  // console.log("datatable columns", columns);
  var defaultOptions = {
    selectableRows: "none",
    responsive: "stacked",
    print: false,
    download: true
  };

  if (title) {
    return /*#__PURE__*/React.createElement(MUIDataTable, {
      "data-cy": "datatable",
      key: key,
      title: title,
      data: data,
      columns: columns || [],
      options: options || defaultOptions,
      className: className
    });
  } else {
    return /*#__PURE__*/React.createElement(MUIDataTable, {
      "data-cy": "datatable",
      key: key,
      title: translation ? translation.title : " ",
      data: data,
      columns: translation ? translation.columns : [],
      options: translation && translation.options || _objectSpread({}, options) || defaultOptions,
      className: className
    });
  }
};

export { DataTable };